import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import Card from "../../../components/Card";
import { AdminApi } from "../../../js/api/admin.api";
import { handleApiError } from "../../../js/helper/errorHandler";
import Swal from "sweetalert2";
import { useTable } from "../components/DataTable/useTable";
import DataTable from "../components/DataTable/DataTable";

const UserList = () => {
  const [adminList, setAdminList] = useState([]);
  const adminType = localStorage.getItem("adminType");
  const isSubAdmin = adminType === "SUB";
  const [isLoading, setIsLoading] = useState(false);
  const { page, limit } = useTable({});
  const columns = [
    { key: "No.", label: "No." },
    { key: "name", label: "Name" },
    { key: "mobile", label: "Mobile" },
    { key: "email", label: "Email" },
    { key: "type", label: "Type" },
    { key: "action", label: "Action" },
  ];

  const fetchAdminData = async () => {
    try {
      setIsLoading(true);
      const response = await AdminApi.getAdmins();
      if (response.data.status === 200) {
        setAdminList(response.data.data);
        setIsLoading(false);
      }
    } catch (error) {
      handleApiError(error, "Failed to fetch admin details");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAdminData();
  }, []);

  const handleDeleteAdmin = async (adminId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This admin will be permanently removed.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
    }).then(async (result) => {
      if (!result.isConfirmed) return; // User canceled

      try {
        const { data } = await AdminApi.removeAdmin({ id: adminId });

        const isSuccess =
          data?.status === 200 || data?.message?.toLowerCase() === "success";

        if (isSuccess) {
          Swal.fire("Deleted!", "Admin has been removed.", "success");

          // Remove from UI list
          fetchAdminData();
          return;
        }

        Swal.fire("Error!", data?.message || "Failed to delete", "error");
      } catch (err) {
        handleApiError(err, "Error deleting admin");
        Swal.fire("Error!", "Server error. Try again.", "error");
      }
    });
  };

  return (
    <>
      <div>
        <Row>
          <Col sm="12">
            <Card>
              <Card.Header className="d-flex justify-content-between">
                <div className="header-title">
                  <h4 className="card-title">Admin List</h4>
                </div>
                <div className="header-title">
                  <Link
                    to="/dashboard/admin-add"
                    className="btn btn-btn btn-primary"
                  >
                    Create Admin
                  </Link>
                </div>
              </Card.Header>
              <Card.Body className="" style={{ position: "relative" }}>
                <div className="table-responsive">
                  <DataTable
                    columns={columns}
                    data={adminList}
                    loading={isLoading}
                    showSearch={false}
                    showLimit={false}
                    page={page}
                    showPagination={false}
                    renderRow={(admin, index) => (
                      <tr key={admin._id}>
                        <td>{((page || 1) - 1) * (limit || 10) + index + 1}</td>
                        <td>{admin.full_name}</td>
                        <td>{admin.mobile}</td>
                        <td>{admin.email}</td>
                        <td>{admin.type}</td>
                        <td>
                          <div className="d-flex align-items-center gap-2">
                            {/* View Button */}
                            <Link
                              to={`/dashboard/admin-profile?id=${admin._id}`}
                              className="btn btn-sm btn-outline-primary action-btn"
                              title="View"
                            >
                              <i className="ri-eye-line"></i>
                            </Link>

                            {!isSubAdmin && (
                              <button
                                onClick={() => handleDeleteAdmin(admin._id)}
                                className="btn btn-sm btn-outline-danger action-btn"
                                title="Delete"
                              >
                                <i className="ri-delete-bin-line"></i>
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    )}
                  />
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default UserList;
